/**
 * Extracts the ID from a user / team ARI.
 */
export function resourceIdFromIdentityAri(ref: string, resource: 'user' | 'team'): string {
	const trimmed = ref.trim();
	if (!trimmed.startsWith('ari:')) {
		return trimmed;
	}
	const label = resource === 'user' ? 'user' : 'team';
	const identityMarker = `::${label}/`;
	const identityIdx = trimmed.indexOf(identityMarker);
	if (identityIdx !== -1) {
		return trimmed.slice(identityIdx + identityMarker.length).split(/[/?#]/)[0] ?? trimmed;
	}
	const slashMarker = `/${label}/`;
	const slashIdx = trimmed.indexOf(slashMarker);
	if (slashIdx !== -1) {
		return trimmed.slice(slashIdx + slashMarker.length).split(/[/?#]/)[0] ?? trimmed;
	}
	return trimmed;
}

const USER_ARI_PREFIX = 'ari:cloud:identity::user/';
const TEAM_ARI_PREFIX = 'ari:cloud:identity::team/';

/**
 * Builds ARI from ID.
 */
export function identityAriFromResourceId(resourceId: string, resource: 'user' | 'team'): string {
	const trimmed = resourceId.trim();
	if (!trimmed) {
		return resource === 'user' ? USER_ARI_PREFIX : TEAM_ARI_PREFIX;
	}
	if (trimmed.startsWith('ari:')) {
		return trimmed;
	}
	return resource === 'user' ? `${USER_ARI_PREFIX}${trimmed}` : `${TEAM_ARI_PREFIX}${trimmed}`;
}
